export interface MedicationEventFhirDetail {
  resourceType?: string;
  name?: string;
  status?: string;
  interpretation?: Array<{
    coding?: Array<{
      code?: string;
    }>;
  }>;
  valueQuantity?: {
    value?: number;
  };
}

export interface MedicationEventDetail {
  fhir?: MedicationEventFhirDetail;
  description?: string;
  scriptWritten?: string;
  homeMedication?: boolean;
  isPrn?: boolean;
  icon?: string;
}

export interface EventTO {
  id: number;
  patient_id: number;
  eventDate: string;
  eventCategory_id?: number;
  eventSubcategory_id?: number;
  detail?: Record<string, any> & Partial<MedicationEventDetail>;
  name?: string;
  source?: string;
  tenancyId?: number;
  episodeId?: number;
  value?: string;
}

export type MedicationEventTO = EventTO & {
  dosage?: string;
};

export const toEventTO = (event: any): EventTO => ({
  id: event.id,
  patient_id: event.patient_id,
  eventDate: event.event_date,
  eventCategory_id: event.event_category_id,
  eventSubcategory_id: event.event_subcategory_id,
  detail: event.detail,
  name: event.name,
  source: event.source,
  tenancyId: event.tenancy_id,
  episodeId: event.episode_id,
  value: event.value,
});
